
(function ($) {
  var that = {};
  var player_lib = that;

  that.showPrev = false;
  that.postPoster = "";
  that.videoId = "";
  that.iframeBlank = 'about:blank';
  that.scheduler = false;

  that.session = {
    getId: function(){
      return parseInt(that.sessionData.id);
    },
    getShow: function(){
      return that.sessionData.show === "1" || that.sessionData.show === true;
    },
    getNow: function(){
      return new Date();
    },
    getCurrentTime: function(){
      return new Date();
    },
    getStartTime: function(){
      return new Date(parseInt(that.sessionData.startTime) * 1000);
    },
    getStartTimeStream: function(){
      var startTimeTimestamp = parseInt(that.sessionData.startTime);

      if(getLibObject("config").startTimeStreamOffset) {
        return new Date((startTimeTimestamp * 1000) - getLibObject("config").startTimeStreamOffset); // x mins before startTime
      }
      return new Date((startTimeTimestamp) * 1000);
    },
    getStartTimePreviewImage: function(){
      var startTimeTimestamp = parseInt(that.sessionData.startTime);

      if(getLibObject("config").startTimePreviewImageOffset) {
        return new Date((startTimeTimestamp * 1000) - getLibObject("config").startTimePreviewImageOffset); // x mins before startTime
      }
      return new Date((startTimeTimestamp - 600) * 1000); // default 10 mins before startTime
    },
    getEndTime: function(){
      return new Date(parseInt(that.sessionData.endTime) * 1000);
    },
    getEndTimePlusX: function(){
      var endTimeTimestamp = parseInt(that.sessionData.endTime);
      return new Date((endTimeTimestamp + 600) * 1000); // 10 mins after endTime
    },
    getStartOfDay: function(){
      return new Date(parseInt(that.sessionData.startOfDay) * 1000);
    },
    getEndOfDay: function(){
      return new Date(parseInt(that.sessionData.endOfDay) * 1000);
    },
    getPostPoster: function(){
      return that.sessionData.postPoster;
    },
    getPrePoster: function(){
      return that.sessionData.prePoster;
    },
    getPostEventUrl: function(){
      return that.sessionData.postEventUrl;
    },
    getEventUrl: function(){
      return that.sessionData.eventUrl;
    },
    getPreEventUrl: function(){
      return that.sessionData.preEventUrl;
    },

    initBbb: function(bbbArr){
      var bbbDom = $('#bigbluebutton');
      if(bbbDom.length && bbbArr.length) {
        var html = "";
        for (var i = 0; i < bbbArr.length; i++) {
          var name = bbbArr[i].name;
          if (bbbArr[i].code && bbbArr[i].code !== "") {
            name += "<br>Zugangscode: " + bbbArr[i].code + "";
          }
          html += getLibObject("config").ajax_templates.bbbMeetingRoom
            .replace("%%NAME%%", name)
            .replace("%%LINK%%", bbbArr[i].url);
        }
        bbbDom.find('>.bbb-rows').html(html);
        bbbDom.removeClass("hide");
      }
    },

    fieldChangedShow: function(newValue){
      if(that.sessionData.show !== newValue) {
        that.sessionData.show = newValue;
        getLibObject("player").determineMode();
      }
    },

    fieldChangedBbbShow: function(newValue){
      var bbbDom = $('#bigbluebutton');
      if(bbbDom.length) { // bbb block exists
        if(newValue === "1") {
          bbbDom.removeClass("bbb-hide");
          bbbDom.addClass("bbb-show");
        } else {
          bbbDom.addClass("bbb-hide");
          bbbDom.removeClass("bbb-show");
        }
      }
    },

    fieldChangedStartTime: function(newValue){
      if(that.sessionData.startTime !== newValue) {
        that.sessionData.startTime = newValue;
        getLibObject("player").determineMode();
        getLibObject("countdown").updateCountdown(new Date(parseInt(newValue) * 1000));
      }
    },

    fieldChangedStartTimeFront: function(newValue){
      if(that.sessionData.startTimeFront !== newValue) {
        that.sessionData.startTimeFront = newValue;
        getLibObject("countdown").updateCountdownFront(new Date(parseInt(newValue) * 1000));
      }
    },

    fieldChangedEndTime: function(newValue){
      if(that.sessionData.endTime !== newValue) {
        that.sessionData.endTime = newValue;
        getLibObject("player").determineMode();
      }
    },

    fieldChangedPreEventUrl: function(newValue){
      if(that.sessionData.preEventUrl !== newValue) {
        that.sessionData.preEventUrl = newValue;
        getLibObject("player").determineMode();
      }
    },

    fieldChangedEventUrl: function(newValue){
      if(that.sessionData.eventUrl !== newValue) {
        that.sessionData.eventUrl = newValue;
        getLibObject("player").determineMode();
      }
    },

    fieldChangedPostEventUrl: function(newValue){
      if(that.sessionData.postEventUrl !== newValue) {
        that.sessionData.postEventUrl = newValue;
        getLibObject("player").determineMode();
      }
    },

    fieldChangedPrePoster: function(newValue){
      if(that.sessionData.prePoster !== newValue) {
        that.sessionData.prePoster = newValue;
        that.session.updatePrePoster(newValue);
      }
    },

    fieldChangedPostPoster: function(newValue){
      if(that.sessionData.postPoster !== newValue) {
        that.sessionData.postPoster = newValue;
        that.session.updatePostPoster(newValue);
      }
    },

    updatePrePoster: function(newValue){
      $("#video").find(".stream-pre-poster").css("background-image","url(" + newValue + ")");
    },

    updatePostPoster: function(newValue){
      $("#video").find(".stream-post-poster").css("background-image","url(" + newValue + ")");
    },

    isVimeo: function(url){
      return url.search("vimeo.com") !== -1;
    }
  };

  that.initVars = function() {
    if(window.sessionData) {
      that.sessionData = window.sessionData;
    } else {
      that.sessionData = {
        "id": '',
        "show": '',
        "now": new Date(),
        "startOfDay": '',
        "endOfDay": '',
        "startTime": '',
        "startTimeFront": '',
        "endTime": '',
        "preEventUrl": '',
        "eventUrl": '',
        "postEventUrl": '',
        "commentStatus": '',
        "current_time": '',
        "prePoster": '',
        "postPoster": ''
      };
    }
  };

  /**
   * update time to change mode if time has come
   * and call determineMode again
   *
   * @param timeDifference
   * @param context
   */
  that.updateScheduler = function(timeDifference, context) {
    var libHelper = getLibObject("helper");
    timeDifference = libHelper.limitNumberTo32BitSigned(timeDifference);
    libHelper.log("updateScheduler: " + timeDifference + " " + context);
    if(timeDifference > 0) {
      clearTimeout(that.scheduler);
      that.scheduler = setTimeout(function(){
        libHelper.log("updateScheduler setTimeout callback called");
        that.determineMode();
      },timeDifference + 3000);
    }
  };

  that.beforeStreamWithTeaser = function(player,iframe,teaser){
    player.removeClass("mode-pre-stream").removeClass("mode-stream").removeClass("mode-post-stream");
    player.addClass("mode-teaser");

    if(!player.hasClass("init-teaser")) {
      player.addClass("init-teaser");
      iframe.attr("src", that.iframeBlank);
      iframe.off("load").on("load",function() {
        iframe.off("load");
        var vimeoPlayer = new Vimeo.Player(iframe[0]);
        player.find(".stream-pre-teaser").click(function(){
          iframe.show();
          vimeoPlayer.play();
          $(this).hide();
        });
      });
      var tmp = teaser;
      if(teaser.substr(0,5) !== "https") {
        tmp = "https://player.vimeo.com/video/" + teaser;
      }
      iframe.attr("src", tmp);
    }
  };

  that.beforeStreamWithoutTeaser = function(player,iframe,commentline){
    player
      .removeClass("mode-teaser")
      .removeClass("mode-stream")
      .removeClass("mode-post-stream")
      .removeClass("init-teaser")
      .removeClass("init-stream")
      .removeClass("init-post-stream")
      .addClass("mode-pre-stream");

    iframe.attr("src", that.iframeBlank);
    iframe.hide();
  };

  that.runningStream = function(player,iframe,commentline,showStream,stream){
    /*commentline.removeClass("hide");
    if(commentline.hasClass('comments')) {
      commentline.removeClass("hide-form");
    }*/
    player.addClass("enable-reload");
    player
      .removeClass("mode-teaser")
      .removeClass("mode-pre-stream")
      .removeClass("mode-post-stream")
      .removeClass("init-teaser")
      .removeClass("init-post-stream")
      .addClass("mode-stream");

    var vimeoPlayer = false;
    var isVimeo = that.session.isVimeo(stream);

    if(!player.hasClass("init-stream")) {
      player.addClass("init-stream");
      player.addClass("show-pause-button");
      player.removeClass("show-play-button");

      iframe.attr("src", that.iframeBlank);

      // on first non blank iframe load
      // init vimeo controls
      /*
      iframe.off("load").on("load",function(){
          if(iframe.attr("src") !== that.iframeBlank) {
              iframe.off("load");

              if (that.session.isVimeo(stream)) {
                  vimeoPlayer = new Vimeo.Player(iframe[0]);
                  that.initVimeoEvents(vimeoPlayer, player);
                  that.initStreamOverlayPlay(vimeoPlayer, player);
                  that.initStreamOverlayPause(vimeoPlayer, player);
              }
          }
      });
      */

      console.log('stream: ');
      console.log(stream);
      console.log('iframe.src: ');
      console.log(iframe.attr('src'));

      if(stream !== iframe.attr("src")) {
        iframe.attr("src", stream);
        if(showStream) {
          iframe.show();
        }
      }

      if(isVimeo) {
        vimeoPlayer = new Vimeo.Player(iframe[0]);
        /* that.initVimeoEvents(vimeoPlayer,player);
        that.initStreamOverlayPlay(vimeoPlayer,player);
        that.initStreamOverlayPause(vimeoPlayer,player); */
        try {
          vimeoPlayer.play();
        } catch(e) {}
      }

    } else {

      console.log('2 stream: ');
      console.log(stream);
      console.log('2 iframe.src: ');
      console.log(iframe.attr('src'));

      if(stream !== iframe.attr("src")) {
        iframe.attr("src", stream);
      }

      // showStream changed
      console.log('showStream:');
      console.log(showStream);
      if(showStream !== that.session.getShow()) {
        if (showStream) {
          iframe.attr("src", stream);
          iframe.show();
          if(isVimeo) {
            vimeoPlayer.play();
          }
        } else {
          iframe.hide();
        }
      } else {
        if(showStream) {
          if(stream !== iframe.attr("src")) {
            iframe.attr("src", stream);
            if(isVimeo) {
              vimeoPlayer.play();
            }
          } else {
            console.log(iframe.css('display'));
            if(iframe.css('display') === 'none') {
              iframe.show();
            }
          }
        }
      }

      // save last state
      that.sessionData.show = showStream;
    }

  };

  that.afterStream = function(player,iframe,commentline,showStream,stream, postPoster, videoId){
    /*if(commentline.hasClass('no-comments')) {
      commentline.addClass("hide-form");
    } else {
      commentline.removeClass('hide-form');
    }*/

    player.addClass("enable-reload");
    player
      .removeClass("mode-teaser")
      .removeClass("mode-pre-stream")
      .removeClass("mode-stream")
      .removeClass("init-teaser")
      .removeClass("init-stream")
      .addClass("mode-post-stream");

    if( !stream || getLibObject("config").afterStreamShowPosterOnly || (postPoster && that.session.getEndTimePlusX() > that.session.getCurrentTime()) ) { // show poster
      player.removeClass("show-play-button");
      player.removeClass("show-pause-button");
      player.removeClass("init-post-stream");
      player.addClass("init-post-background");
      $(".stream-post-poster").show();
      iframe.attr("src", that.iframeBlank);
      iframe.hide();
    } else { // show vimeo video
      // videoId

      $(".stream-post-poster").hide();
      var firstRun = false;
      var vimeoPlayer = false;
      var isVimeo = false;

      if(!videoId) {
        videoId = stream;
      }

      if( ("" + videoId).substr(0,8) !== "https://" ) {
        videoId = "https://player.vimeo.com/video/" + videoId;
      }

      isVimeo = that.session.isVimeo(videoId);

      if(!player.hasClass("init-post-stream")) {
        firstRun = true;

        player.addClass("init-post-stream");
        player.removeClass("init-post-background");
        player.addClass("show-pause-button");
        player.removeClass("show-play-button");

        iframe.attr("src", that.iframeBlank);
        iframe.off("load").on("load",function(){
          iframe.off("load");
          if(isVimeo) {
            vimeoPlayer = new Vimeo.Player(iframe[0]);

            that.initVimeoEvents(vimeoPlayer, player);
            that.initStreamOverlayPlay(vimeoPlayer, player);
            that.initStreamOverlayPause(vimeoPlayer, player);
          } else {
            vimeoPlayer = false;
          }

          // compare with last state
          if(firstRun || showStream !== that.showPrev) {
            if(showStream) {
              iframe.show();
              if(vimeoPlayer) {
                vimeoPlayer.play();
              }
            } else {
              iframe.hide();
              if(vimeoPlayer) {
                vimeoPlayer.stop();
              }
            }
          }

          // save last state
          that.showPrev = showStream;
        });

        iframe.attr("src", videoId);
        iframe.show();

      } else {
        if(videoId !== iframe.attr("src")) {
          iframe.attr("src",videoId);
        }
        if(isVimeo) {
          vimeoPlayer = new Vimeo.Player(iframe[0]);
        } else {
          vimeoPlayer = false;
        }

        // compare with last state
        if(firstRun || showStream !== that.showPrev) {
          if(showStream) {
            iframe.show();
            if(vimeoPlayer) {
              vimeoPlayer.play();
            }
          } else {
            iframe.hide();
            if(vimeoPlayer) {
              vimeoPlayer.stop();
            }
          }
        }

        // save last state
        that.showPrev = showStream;
      }
    }
  };

  that.determineMode = function() {

    var showStream = that.session.getShow();

    var player = $("#player");
    var iframe = $("#stream");
    var commentline = $('#commentline');

    console.log(showStream);
    console.log(player);

    if (showStream !== false) {
      showStream = true;
    }

    if(showStream) {
      player.removeClass("is-not-stream").addClass("is-stream");
      commentline.removeClass("is-not-stream").addClass("is-stream");
    } else {
      player.removeClass("is-stream").addClass("is-not-stream");
      commentline.removeClass("is-stream").addClass("is-not-stream");
      iframe.attr("src", that.iframeBlank);
      player.removeClass("init-teaser").removeClass("init-stream").removeClass("init-post-stream");
    }

    var now = new Date();

    // check if local time is plausible (new Date() = system time)
    // currentTime could be cached and a bit older but not newer then now
    // caching should be max 5 min
    // if difference is greater 10 min use currentTime
    console.log(now);
    console.log(that.session.getCurrentTime().getTime());
    if (
      now < that.session.getCurrentTime().getTime() ||
      now > (that.session.getCurrentTime().getTime() - 600000)
    ) {
      that.sessionData.now = that.session.getCurrentTime();
    } else {
      that.sessionData.now = now;
    }

    // update countdown
    if( that.session.getNow() < that.session.getStartTime() ) {
      var timeDifference = that.session.getStartTime().getTime() - that.session.getCurrentTime().getTime();
      var calculatedStartDate = 0;

      // calculate differen betweeen date from html and startdate from html
      // add difference to current local time

      if(timeDifference > 0) {
        calculatedStartDate = new Date( ( new Date()).getTime() + timeDifference );
        console.log('new start:');
        console.log(calculatedStartDate);
        getLibObject("countdown").updateCountdown(calculatedStartDate);
      }
    }

    var postPoster = that.session.getPostPoster(),
      postEventUrl = that.session.getPostEventUrl(),
      preEventUrl = that.session.getPreEventUrl();

    if( that.session.getNow() < that.session.getStartTimePreviewImage() && preEventUrl ) {
      console.log(1);
      // before stream and with teaser
      that.updateScheduler(that.session.getStartTimePreviewImage().getTime() - that.session.getNow().getTime(), "beforeStreamWithTeaser");
      that.beforeStreamWithTeaser(player,iframe,preEventUrl);
    } else if( that.session.getNow() < that.session.getStartTimePreviewImage() ) {
      console.log(2);
      // before stream but without teaser
      that.updateScheduler(that.session.getStartTimePreviewImage().getTime() - that.session.getNow().getTime(), "beforeStreamWithoutTeaser");
      that.beforeStreamWithoutTeaser(player,iframe,commentline);
    } else if( that.session.getNow() < that.session.getStartTimeStream() ) {
      console.log(3);
      // shortly before stream with previewimage
      that.updateScheduler(that.session.getStartTimeStream().getTime() - that.session.getNow().getTime(), "beforeStreamWithoutTeaser");
      that.beforeStreamWithoutTeaser(player,iframe,commentline);
    } else if( that.session.getNow() <= that.session.getEndTime() ) {
      console.log(4);
      // streaming
      that.updateScheduler(that.session.getEndTime().getTime() - that.session.getNow().getTime(), "runningStream");
      that.runningStream(player,iframe,commentline,showStream,that.session.getEventUrl());
    } else if( that.session.getNow() <= that.session.getEndTimePlusX() ) {
      console.log(5);
      // after stream with reviewimage
      that.processRedirectUrl();
      that.updateScheduler(that.session.getEndTimePlusX().getTime() - that.session.getNow().getTime(), "afterStream");
      that.afterStream(player, iframe, commentline, showStream, false, postPoster, postEventUrl);
    } else if( that.session.getNow() <= that.session.getEndOfDay() ) {
      console.log(6);
      // till end of day
      that.processRedirectUrl();
      that.afterStream(player, iframe, commentline, showStream, postEventUrl, postPoster, postEventUrl);
    } else { // days after stream, fallback
      console.log(7);
      that.processRedirectUrl();
      that.afterStream(player, iframe, commentline, showStream, postEventUrl, postPoster, postEventUrl);
    }

    player.removeClass("hide");
  };

  that.processRedirectUrl = function() {
    if(typeof that.sessionData.redirectUrl !== "undefined" &&
      that.sessionData.redirectUrl &&
      that.sessionData.redirectUrl !== "" ) {
      window.location.href = that.sessionData.redirectUrl;
    }
  };

  that.initStreamOverlayPause = function (vimeoPlayer,player) {
    $(".stream-overlay-pause").off("click").on("click",function(){
      vimeoPlayer.pause();
      player.removeClass("show-pause-button");
      player.addClass("show-play-button");
    });
  };

  that.initStreamOverlayPlay = function (vimeoPlayer,player) {
    $(".stream-overlay-play").off("click").on("click",function(){
      vimeoPlayer.getEnded().then(function(ended) {
        // ended = whether or not the video has ended
        if(ended) {
          // starts automatically on setCurrentTime
          player.setCurrentTime(0).then(function(seconds) {
            //
          }).catch(function(error) {
            vimeoPlayer.play();
          });
        } else {
          vimeoPlayer.play();
        }
      }).catch(function(error) {
        vimeoPlayer.play();
      });
    });
  };

  that.initVimeoEvents = function (vimeoPlayer,player) {
    vimeoPlayer.off('play');
    vimeoPlayer.on('play', function() {
      player.removeClass("show-play-button");
      player.addClass("show-pause-button");
    });

    vimeoPlayer.off('bufferstart');
    vimeoPlayer.on('bufferstart', function() {
      player.removeClass("show-play-button");
      player.addClass("show-pause-button");
    });

    vimeoPlayer.off('bufferend');
    vimeoPlayer.on('bufferend', function() {
      player.removeClass("show-play-button");
      player.addClass("show-pause-button");
    });

    vimeoPlayer.off('pause');
    vimeoPlayer.on('pause', function() {
      player.removeClass("show-pause-button");
      player.addClass("show-play-button");
    });

    vimeoPlayer.off('ended');
    vimeoPlayer.on('ended', function() {
      player.removeClass("show-pause-button");
      player.addClass("show-play-button");
    });
  };

  that.mutePlayer = function (event) {
    event.target.mute();
  };

  that.showPlayer = function (event) {
    $("#header-video").find("#playerHeader").css("display", "block");
  };

  that.createBackgroundPlayer = function (videoID, element) {
    var playerHeader = new YT.Player(element, {
      playerVars: {
        'autoplay': 1,
        'controls': 0,
        'showinfo': 0,
        'disablekb': 1,
        'autohide': 1,
        'html5': 1,
        'modestbranding': 1,
        'loop': 1,
        'rel': 0,
        'playlist': videoID,
        'iv_load_policy': 3,
        'enablejsapi': 1,
        'wmode': 'transparent'
      },

      autoplay: 1,
      controls: 0,
      showinfo: 0,
      disablekb: 1,
      autohide: 1,
      html5: 1,
      rel: 0,
      modestbranding: 1,
      loop: 1,
      playlist: videoID,
      iv_load_policy: 3,
      enablejsapi: 1,

      videoId: videoID,
      events: {
        'onReady': function (event) {
          that.mutePlayer(event);
          //  showPlayer();
        }
      },
      wmode: 'transparent'
    });
  };

  that.createPlayer = function (videoID, element, _autoplay) {
    var autoplay = typeof _autoplay !== 'undefined' ? _autoplay : true;
    var playerHeader = new YT.Player(element, {
      playerVars: {
        'autoplay': autoplay ? 1 : 0,
        'autohide': 1,
        'showinfo': 0,
        'rel': 0,
        'html5': 1,
        'modestbranding': 1,
        'iv_load_policy': 3,
        'enablejsapi': 1,
        'wmode': 'transparent'
      },

      videoId: videoID,
      events: {
        'onReady': function (event) {
        }
      }
    });
  };

  that.createVimeoPlayer = function (videoID, element, _autoplay, _mute) {

    $('#' + element).on("load", function () {
      var iframe = $('#' + element)[0];
      var player = new Vimeo.Player(iframe);
      var status = $('.status');

      if (_mute) {
        player.setVolume(0).catch(function(error) {
          console.error('error setting video volume:', error.name);
        });
      }
    });

    /*
     //load vimeo with oembed => problems with froogaloop iframe selection
     //and getting control over created player api
     var videoUrl = '//www.vimeo.com/' + videoID;
     var endpoint = '//www.vimeo.com/api/oembed.json';
     var callback = 'embedVimeo';

     var parameter = {
     callback: callback,
     api: 1,
     player_id: 'vimeo_player',
     title: 0,
     portrait: 0,
     autoplay: _autoplay,
     loop: 1,
     autopause: 1,
     byline: 0,
     //	 width: 640 ,
     //	 height: 480 ,
     };

     var url = endpoint + '?url=' + encodeURIComponent(videoUrl);

     //add arguments
     for(var key in parameter){
     url =  url + '&' + key + "=" + parameter[key];
     }

     var js = document.createElement('script');

     js.setAttribute('type', 'text/javascript');
     js.setAttribute('src', url);

     document.getElementsByTagName('head').item(0).appendChild(js);
     */
  };

  that.fieldChangedFeedbackFormShow = function(value) {
    var element = $('#feedback_popup');
    if (value === '1' && element.length > 0) {
      if(!window.feedbackFormWasActive) { // popup has been shown, dont try again
        $.fancybox(
          $('#feedback_popup'),
          {
            width: 300,
            minHeight: 0,
            leftRatio: 0.9,
            helpers:  {
              overlay : null
            }
          });
        window.feedbackFormWasActive = true;
      }
    } else {
      $.fancybox.close();
    }
  };

  that.fieldChangedFeedbackFormUrl = function(value) {
    if (value !== '') {
      $('#feedback_popup a').attr('href', value);
    }
  };

  that.fieldChangedRedirectUrl = function(value) {
    that.sessionData.redirectUrl = value;
    var redirect_button = $("#redirect-button .btn");
    if(redirect_button.length) {
      redirect_button.attr("href",value);
    }
  };

  that.disableWebsocketIfAfterEventDay = function() {
    var player = $("#player");
    if(player.length) {
      var currentDateInSeconds = parseInt((new Date()).getTime() / 1000);
      var endOfDay = parseInt(player.attr("data-endOfDay"));
      if(currentDateInSeconds > endOfDay) {
        // after event day
        getLibObject("config").websocketEnabled = false;
      }
    }
  };

  that.disableWebsocketIfBeforeEventDay = function() {
    var player = $("#player");
    if(player.length) {
      var currentDateInSeconds = parseInt((new Date()).getTime() / 1000);
      var startOfDay = parseInt(player.attr("data-startOfDay"));
      if(currentDateInSeconds < startOfDay) {
        // after event day
        getLibObject("config").websocketEnabled = false;
      }
    }
  };

  window.vrnetworld.player = that;
})(jQuery); // Fully reference jQuery after this point.
